module.exports = __webpack_public_path__ + "static/media/11NEPAD3.e0c1497c.jpg";